var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"house_ad"},[_c('img',{attrs:{"src":require('@/assets/imgs/aboutUs/house_ad_details.png'),"alt":"名盛房产"}})])}
var staticRenderFns = []

export { render, staticRenderFns }